import _isNil from 'lodash/isNil';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '@Components/Button/Button';
import TextInput from '@Components/DomElements/TextInput';
import LoadingButton from '@Components/LoadingButton/LoadingButton';
import Styles from '@Components/Settings/views/SettingsViews.scss';
import TeamsApi from '@Data/teams/Api';
import { IUpdateTeam } from '@Data/teams/Interfaces';
import { selectedTeamState } from '@Data/teams/Reducer';
import { ISettingsBaseComponentProps } from '../../Interfaces';

const emptyUpdateTeam = {
    teamId: '',
    organisationId: '',
    teamName: '',
    ownerEmail: '',
    isActive: true,
};

const TeamInfoUpdateScreen = (props: ISettingsBaseComponentProps) => {
    const { title, isSubmitting, setIsSubmitting, id } = props;
    const selectedTeam = useSelector(selectedTeamState);
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [updateTeamEntity, setUpdateTeamEntity] =
        useState<IUpdateTeam>(emptyUpdateTeam);

    useEffect(() => {
        if (_isNil(selectedTeam)) {
            //
        } else {
            setUpdateTeamEntity({
                teamId: selectedTeam.team_id,
                organisationId: selectedTeam.organisation_fk,
                teamName: selectedTeam.team_name,
                ownerEmail: selectedTeam.owner_email,
                isActive: selectedTeam.is_active,
            });
        }
    }, [selectedTeam]);

    const getTeams = async (orgId, teamId?) => {
        // setIsLoading(true);
        await TeamsApi.getOrganizationTeams(orgId, teamId);
        // setIsLoading(false);
    };

    const handleCancelUpdateTeam = () => {
        setIsEditing(false);
        if (!_isNil(selectedTeam)) {
            setUpdateTeamEntity({
                teamId: selectedTeam.team_id,
                organisationId: selectedTeam.organisation_fk,
                teamName: selectedTeam.team_name,
                ownerEmail: selectedTeam.owner_email,
                isActive: selectedTeam.is_active,
            });
        }
    };

    const submitCleanup = async () => {
        setIsEditing(false);
        setIsSubmitting(false);
    };

    const handleSubmitUpdateTeam = async () => {
        setIsSubmitting(true);
        const team = await TeamsApi.updateTeam(
            updateTeamEntity.teamId,
            updateTeamEntity.organisationId,
            updateTeamEntity.teamName,
            updateTeamEntity.ownerEmail,
            updateTeamEntity.isActive
        );
        if (!_isNil(team)) {
            await getTeams(updateTeamEntity.organisationId, team.team_id);
        }
        submitCleanup();
    };

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setUpdateTeamEntity({
            ...updateTeamEntity,
            [e.target.name]: e.target.value,
        });
    };

    return (
        <div className={Styles.settingsViewWrapper}>
            <div className={Styles.settingsViewHeader}>
                <span id={`${id}-title`}>{title}</span>
                <div>
                    {isEditing ? (
                        <div style={{ display: 'flex', gap: '1rem' }}>
                            <Button
                                id={`cancel-edit-${id}-btn`}
                                color={'black'}
                                onClick={handleCancelUpdateTeam}
                            >
                                Cancel
                            </Button>
                            <LoadingButton
                                id={`submit-edit-${id}-btn`}
                                color={'success'}
                                loading={isSubmitting}
                                disabled={updateTeamEntity.teamName === ''}
                                onClick={handleSubmitUpdateTeam}
                            >
                                Submit
                            </LoadingButton>
                        </div>
                    ) : (
                        <Button
                            id={`edit-${id}-btn`}
                            color={'blue'}
                            onClick={() => setIsEditing(true)}
                        >
                            Edit
                        </Button>
                    )}
                </div>
            </div>
            <div className={Styles.settingsViewContent}>
                {
                    <TextInput
                        id={`edit-${id}-input`}
                        label={'Team Name'}
                        name={'teamName'}
                        containerStyle={{ width: '100%' }}
                        value={updateTeamEntity.teamName}
                        onChange={onChange}
                        isEditing={isEditing}
                    />
                }
            </div>
        </div>
    );
};

export default TeamInfoUpdateScreen;
